

let globalGet = null;
let isRequesting = false;
export const waitForGet = (api, fn)=>{
    if(!isRequesting){
        isRequesting = true;
        (async ()=>{
            globalGet = await api.get();
            fn(globalGet);
        })();
    } else {
        let retry = 0;
        let interval = setInterval(()=>{
            retry++;
            if(globalGet !== null){
                clearInterval(interval);
                fn(globalGet);
            } else if(retry > 10){
                clearInterval(interval);
            }
        }, 600);
    }
}